import React from 'react';
import PropTypes from 'prop-types';

import { Gallery } from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import { contentFolderHasItems } from 'design-comuni-plone-theme/helpers';

//const messages = defineMessages({});

const EventoGallery = ({ content }) => {
  //const intl = useIntl();

  return contentFolderHasItems(content, 'immagini') ||
    contentFolderHasItems(content, 'video') ? (
    <>
      <Gallery
        content={content}
        folder_name={'immagini'}
        className="mt-4 pb-4"
        title_type="h2"
      />

      <Gallery
        content={content}
        folder_name={'video'}
        title_type="h2"
        title_id="galleria_video"
        title_video="Video"
      />
    </>
  ) : null;
};

EventoGallery.propTypes = {
  content: PropTypes.shape({
    descrizione_estesa: PropTypes.object,
    descrizione_destinatari: PropTypes.shape({
      data: PropTypes.string,
    }),
    persone_amministrazione: PropTypes.array,
  }).isRequired,
};

export default EventoGallery;
